type VisibleInlineTagCountArgs = {
  /** Natural (unclipped) width of each chip, in source order. */
  readonly chipWidths: readonly number[];
  readonly gapPx: number;
  readonly availableWidth: number;
  /** Width of the "+N" button, reserved whenever at least one chip has to be dropped. */
  readonly overflowWidth: number;
};

/**
 * How many chips fit before the "+N" overflow button has to take over. Every candidate chip must
 * leave room for the gap and the button after it, so the count never depends on how many chips are
 * currently rendered — which is what lets the caller cache measured widths and recompute on resize
 * without re-measuring a row it has already clipped.
 */
export function visibleInlineTagCount({
  chipWidths,
  gapPx,
  availableWidth,
  overflowWidth,
}: VisibleInlineTagCountArgs): number {
  if (chipWidths.length === 0) return 0;

  const naturalWidth = chipWidths.reduce((total, width) => total + width, 0) + gapPx * (chipWidths.length - 1);
  if (naturalWidth <= availableWidth) return chipWidths.length;

  let used = 0;
  let count = 0;
  for (const width of chipWidths) {
    const widthWithGap = count === 0 ? width : gapPx + width;
    if (used + widthWithGap + gapPx + overflowWidth > availableWidth) break;
    used += widthWithGap;
    count += 1;
  }
  return count;
}
